import produce from "immer";

import {
  GET_APPROVE_RETURN_INVOICE_FAILURE,
  GET_APPROVE_RETURN_INVOICE_REQUEST,
  GET_APPROVE_RETURN_INVOICE_SUCCESS
} from "src/actions/approveReturnInvoice";

const initialState = {
  invoices: [],
  invoice: {},
  total: 0,
  loading: false
};

const invoiceReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_APPROVE_RETURN_INVOICE_REQUEST: {
      return produce(state, (draft) => {
        draft.invoices = [];
        draft.loading = true;
      });
    }

    case GET_APPROVE_RETURN_INVOICE_SUCCESS: {
      const {response, total} = action.payload;
      return produce(state, (draft) => {
        draft.invoices = response;
        draft.loading = false;
        draft.total = total;
      });
    }

    case GET_APPROVE_RETURN_INVOICE_FAILURE: {
      return produce(state, (draft) => {
        draft.loading = false;
      });
    }
    default: {
      return state;
    }
  }
};

export default invoiceReducer;
